import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainee_migration",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Migration")
  ])
], -1)
const _hoisted_3 = {
  id: "trainee_migration",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Quarter", -1)
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Disbursement Date", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-5 mb-xl-10" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-header border-0 cursor-pointer bg-success",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#upload_file",
    "aria-expanded": "true",
    "aria-controls": "form"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Upload File")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    id: "upload_file",
    class: "collapse show"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "collapse show" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-body border-top p-4" }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "current",
          "data-kt-stepper-element": "content"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
              /*#__PURE__*/_createElementVNode("label", { class: "form-label" }),
              /*#__PURE__*/_createElementVNode("br"),
              /*#__PURE__*/_createElementVNode("input", {
                type: "file",
                class: "form-control"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 mt-5" }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "submit",
                class: "btn btn-success btn-md"
              }, " Submit ")
            ])
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course",
                      modelValue: _ctx.batch.course,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.course) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Q1",
                          value: "1",
                          selected: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Q1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Q2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Q2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Q3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Q3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Q4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Q4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _hoisted_12,
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.batch.disbursement_date,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.disbursement_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          type: "date",
                          style: {"width":"100%"},
                          name: "disbursement_date"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_13
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}